// This is a direct re-export of the process module
import process from 'process/browser';

// Ensure process is available globally
if (typeof window !== 'undefined') {
    window.process = process;
}

export default process; 